import { render, staticRenderFns } from "./SIdentify.vue?vue&type=template&id=004711d7&scoped=true"
import script from "./SIdentify.vue?vue&type=script&lang=js"
export * from "./SIdentify.vue?vue&type=script&lang=js"
import style0 from "./SIdentify.vue?vue&type=style&index=0&id=004711d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004711d7",
  null
  
)

export default component.exports